/** Only fields supported by TC's lander contract. For Media Devoted | Created By Ciro Autiero */
import { Input } from '@/components/ui/form/input/Input';
import type { TcLanderForm } from '@/features/flow-optimizer/tracker-entities/tres-commas/lander-form';
type Props = { values: TcLanderForm; patch: (v: Partial<TcLanderForm>) => void; disabled: boolean };
const TEXT = { namePostfix: 'Name postfix', url: 'Lander URL', countryCode: 'Country code (optional)', tagsCsv: 'Tags (comma-separated)', noteText: 'Notes', preferredTrackingDomain: 'Preferred tracking domain' } as const;
function TextFields({ values, patch, disabled }: Props) {
  return <>{Object.entries(TEXT).map(([field, label]) => <label key={field} className="block space-y-1 text-sm">
    <span>{label}</span><Input value={values[field as keyof typeof TEXT]} disabled={disabled}
      onChange={(e) => patch({ [field]: e.target.value })} />
  </label>)}</>;
}
export function TcLanderFields(props: Props) {
  const { values, patch, disabled } = props;
  return <div className="space-y-3"><TextFields {...props} />
    <label className="block text-sm">Type <select value={values.landerType} disabled={disabled}
      onChange={(e) => patch({ landerType: e.target.value as TcLanderForm['landerType'] })}>
      <option value="LANDER">Lander</option><option value="PRELANDER">Pre-lander</option></select></label>
    <label className="block text-sm">Number of offers <Input type="number" min={1} value={values.numberOfOffers}
      disabled={disabled} onChange={(e) => patch({ numberOfOffers: Number(e.target.value) })} /></label>
    <label className="flex gap-2 text-sm"><input type="checkbox" checked={values.shouldHaveTrackingScript}
      disabled={disabled} onChange={(e) => patch({ shouldHaveTrackingScript: e.target.checked })} />Track without redirects</label>
  </div>;
}
